/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { AlarmIcon, TimesIcon, CheckmarkIcon, LogoLargeIcon, TrendUp, TrendDown } from 'shared/components/Icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { collectProductInfo } from 'utils/projectHelpers';
import { ProductImageBlock } from './ProductImageBlock';
import moment from 'moment';
import ActionButtons from './ActionButtons';
import { showPrice } from 'utils/appHelpers';
import CheckBox from '../CheckBox';
import { getLocalizedPath } from 'utils/languageHelpers';

const ProductBlock = ({
  product,
  actionButtons,
  showAlarm,
  notAvailable,
  showDate,
  hideProductClick,
  onSelectToggle,
  selected,
  onProductClick,
  isCheckbox,
  className,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  if (!product) return null;

  const { mainImage, favIcon, name, thumbnails, priceTrand } = collectProductInfo(product);

  const goProductPage = () => {
    const id = product.likiee?.id || product.id;
    history.push(getLocalizedPath(`/likiee/${id}`));
  };

  const PriceTrandIcon = priceTrand ? (priceTrand === 'up' ? TrendUp : TrendDown) : null;
  const productClick = hideProductClick ? null : onProductClick ? onProductClick : goProductPage;

  return (
    <div className={`product-item-block ${className || ''}`}>
      <div
        className={`image-block d-flex flex-column ${hideProductClick ? '' : 'cursor-pointer'}`}
        onClick={productClick}
      >
        {favIcon && (
          <div className='item-logo'>
            <img src={favIcon} alt='limg' />
          </div>
        )}
        {notAvailable && (
          <div className='no-available-box px-2 px-md-4 py-1 py-md-2 d-flex align-items-center'>
            <TimesIcon className='svg-white mr-1' /> {t('text_not_available')}
          </div>
        )}
        {showAlarm && product.priceAlertId && !onSelectToggle && (
          <button className='btn p-0 right-corner action-btn text-center'>
            <AlarmIcon />
          </button>
        )}
        {onSelectToggle && !isCheckbox && (
          <button
            className={`btn p-0 right-corner action-btn text-center bg-white shadow ${!selected && 'is-logo'}`}
            onClick={onSelectToggle.bind(null, selected, product)}
          >
            {selected ? <CheckmarkIcon className='svg-black' /> : <LogoLargeIcon />}
          </button>
        )}
        {onSelectToggle && isCheckbox && (
          <div className='position-absolute r-0 mr-2 mt-2 t-16'>
            <CheckBox
              className='mb-0'
              label={' '}
              id={product.id}
              name='select'
              checked={selected}
              onChange={onSelectToggle.bind(null, selected, product)}
            />
          </div>
        )}
        <ProductImageBlock images={thumbnails} mainImage={mainImage} status={product.status} slideMaxCount={3} />
        {actionButtons && <ActionButtons buttons={actionButtons} />}
      </div>
      <div className='project-info mt-5'>
        <p
          className={`mb-5 mb-md-7 text-lg text-line-2 fw-500 ${productClick && 'cursor-pointer'}`}
          onClick={productClick}
        >
          {name}
        </p>
        <div className='d-flex align-items-center justify-content-between'>
          {!product.discountPrice && (
            <p
              className={`mb-0 text-lg d-flex align-items-center ${productClick && 'cursor-pointer'}`}
              onClick={productClick}
            >
              <span>{showPrice(product)}</span>
              {PriceTrandIcon && <PriceTrandIcon className='ml-4' />}
            </p>
          )}
          {product.discountPrice && (
            <div className={`d-flex align-items-center ${productClick && 'cursor-pointer'}`} onClick={productClick}>
              <p className='mb-0 text-lg text-primary'>{showPrice(product, 'discountPrice')}</p>
              <p className='mb-0 ml-8 text-gray-dark text-line-through'>{showPrice(product)}</p>
            </div>
          )}
          {showDate && <p className='mb-0 text-lg text-gray-dark'>{moment(product.createdAt).format('DD.MM.YY')}</p>}
        </div>
      </div>
    </div>
  );
};

export default ProductBlock;
